// Turns a rejected external-IdP token exchange into the text the error page shows. Kept free of any
// runtime dependency (no stores, no ROUTES) so it can be unit-tested under Jest's node environment.

import { ISsoCallbackErrorEnvelope } from '@app/src/common/model/SsoCallbackError';

// Only a 400 carries a server-authored explanation worth showing — that is the status behind the
// reported failures (e.g. UM0014 External Id must be unique). A network error, a 5xx or an aborted
// request has no wording the user could act on, so the page keeps its generic message.
export const buildCallbackErrorMessage = (error?: {
  response?: { status?: number; data?: ISsoCallbackErrorEnvelope };
}): string => {
  if (error?.response?.status !== 400) {
    return '';
  }
  const { Code, Message } = error.response.data || {};
  return [Code, Message].filter(Boolean).join(': ');
};

// Hash-router URL, so assigning it from /callback is the full document load that leaves the callback
// pathname behind.
export const buildErrorPageUrl = (path: string, message: string): string =>
  message ? `/#${path}?message=${encodeURIComponent(message)}` : `/#${path}`;
